<mwe-modal [model]="popupModel()">
  <h1 class="h4">{{ 'tariffChange.selectionPopup.heading' | translate }}</h1>
  <h2 class="h5">{{ 'tariffChange.selectionPopup.description' | translate }}</h2>

  <div class="row mb-3 g-4">
    @if (hasStromGas()) {
      <div class="col-lg-6">
        <mwe-clickable-products-card
          (cardClicked)="startStromGasTariffChange()"
          [categories]="[Sparte.Strom, Sparte.Gas, Sparte.Fernwaerme]"
          [hasAutoFocus]="true"
          [textNodeType]="'h3'"
          ariaTitle="tariffChange.selectionPopup.stromGas"
          dataTest="tariff-change-selection-strom-gas"
        >
          <p class="text--legal mb-0">{{ stromCompany() }}</p>
        </mwe-clickable-products-card>
      </div>
    }

    @if (hasEmobility()) {
      <div class="col-lg-6">
        <mwe-clickable-products-card
          (cardClicked)="startEmobilityTariffChange()"
          [categories]="[Sparte.Emobility]"
          [disabled]="isEmobilityDisabled()"
          [textNodeType]="'h3'"
          ariaTitle="tariffChange.selectionPopup.emobility"
          dataTest="tariff-change-selection-emobility"
        >
          @if (isEmobilityDisabled()) {
            <mwe-badge
              class="d-block mt-1"
              type="warning"
              text="tariffChange.products.cardMessage.notAvailableOnline"
              size="sm"
              emphasis="bold"
              iconClass="fas fa-exclamation-circle"
            />
          } @else {
            <p class="text--legal mb-0">{{ emobilityCompany() }}</p>
          }
        </mwe-clickable-products-card>
      </div>
    }
  </div>
</mwe-modal>
